import React, { useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const useStyles = makeStyles({
  // style rule
  tooltipContainer: props => ({
    top: 0,
    left: 0,
    position: "absolute",
    zIndex: 2,
    width: props.width,
    transform: `translate3d( ${props.left}px, ${props.top}px, 0px )`
  }),
  tooltipInner: {
    backgroundColor: "#003767",
    position: "absolute",
    display: "flex",
    bottom: 15,
    fontSize: 14,
    left: "50%",
    transform: "translateX(-50%)",
    borderRadius: 5,
    padding: 8,
    width: 110,
    alignItems: "center",
    justifyContent: "space-between",
    color: "#fff",
    "&:after": {
      position: "absolute",
      content: '""',
      top: "100%",
      left: "50%",
      marginLeft: "-5px",
      borderWidth: 5,
      borderStyle: "solid",
      borderColor: "#002c52 transparent transparent transparent"
    }
  },
  tooltipBtn: {
    color: "#002c52",
    background: "#ffffffc7",
    "&:hover": {
      background: "#FFF"
    },
    "& svg": {
      height: 19,
      width: 19
    }
  }
});

function useOutsideClick(ref, closingMethod) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        closingMethod();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export default function TextTooltip(props) {
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, props.closeTooltip);
  const classes = useStyles(props.coordinates);
  return (
    <div ref={wrapperRef} className={classes.tooltipContainer}>
      <div className={classes.tooltipInner}>
        {props.text}
        <IconButton onClick={e => props.openModal(props.index, "ent")} className={classes.tooltipBtn} size="small">
          <ArrowForwardIcon />
        </IconButton>
      </div>
    </div>
  );
}
